import '@Scss/app.scss';

// Components
import events from './helpers/events';
import general from './core/general';
import footer from './components/footer';
import news from './components/news';
import search from './components/search';
import products from './components/products';

// Import all
const modules = [general, footer, events, news, search, products];
modules.forEach(module => {
  module();
});

// Dynamic components import
const components = [{
  el: 'header',
  fileName: 'core/header'
}, {
  el: 'video',
  fileName: 'components/video'
}, {
  el: '.media__video',
  fileName: 'components/video-player'
}, {
  el: '.accordion',
  fileName: 'plugins/accordion'
}, {
  el: '.dropdown',
  fileName: 'plugins/dropdown'
}, {
  el: '.ce-card_group',
  fileName: 'components/card-group'
}, {
  el: '.ce-card_group_slider',
  fileName: 'components/card-group-slider'
}, {
  el: '.ce-fullscreen_tabs',
  fileName: 'components/fullscreen-tab'
}, {
  el: '.ce-history',
  fileName: 'components/history'
}, {
  el: '.ce-horizontal_tabs',
  fileName: 'components/horizontal-tabs'
}, {
  el: '.ce-scroll_tabs',
  fileName: 'components/scroll-tabs'
}, {
  el: '.ce-vertical_tabs',
  fileName: 'components/vertical-tabs'
}, {
  el: '.js-image-swiper-slider',
  fileName: 'components/image-slider'
}];
const componentImport = async (el, fileName) => {
  if (!document.querySelector(el)) return;
  const module = await import(`./${fileName}`);
  // Initialize module
  if (typeof module === 'function') {
    module();
  } else if (typeof module === 'object' && typeof module.default === 'function') {
    module.default();
  }
};
components.forEach(component => {
  const {
    el,
    fileName
  } = component;
  componentImport(el, fileName);
});